<template>
  <span class="loading-spinner spinner-border" v-show="visible"></span>
</template>

<script>
export default {
  data() {
    return {
      visible: false
    };
  },

  created() {
    this.$root.$on("loading:show", () => {
      this.visible = true;
    });

    this.$root.$on("loading:hide", () => {
      this.visible = false;
    });
  }
};
</script>

<style scoped>
.loading-spinner {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 10000;
}
</style>